import { render, staticRenderFns } from "./MSOMenu.vue?vue&type=template&id=2d636598&"
import script from "./MSOMenu.vue?vue&type=script&lang=js&"
export * from "./MSOMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports